.positioner {
	z-index: var(--zindex-tooltip);
}

.popup {
	box-sizing: border-box;
	max-width: var(--tooltip-max-width);
	padding: var(--padding-base-y) var(--padding-base-x);
	color: var(--tooltip-color);
	font-size: var(--font-size-base);
	line-height: var(--line-height-base);
	text-align: center;
	background-color: var(--tooltip-bg);
	border-radius: var(--border-radius-base);
	transition: opacity 150ms linear;
}

.popup[data-starting-style],
.popup[data-ending-style] {
	opacity: 0;
}

.popup[data-instant] {
	transition: none;
}

.arrow {
	width: 0;
	height: 0;
	border: var(--tooltip-arrow-width) solid transparent;
}

.arrow[data-side="top"] {
	bottom: calc(var(--tooltip-arrow-width) * -1);
	border-bottom-width: 0;
	border-top-color: var(--tooltip-bg);
}

.arrow[data-side="bottom"] {
	top: calc(var(--tooltip-arrow-width) * -1);
	border-top-width: 0;
	border-bottom-color: var(--tooltip-bg);
}

.arrow[data-side="left"] {
	right: calc(var(--tooltip-arrow-width) * -1);
	border-right-width: 0;
	border-left-color: var(--tooltip-bg);
}

.arrow[data-side="right"] {
	left: calc(var(--tooltip-arrow-width) * -1);
	border-left-width: 0;
	border-right-color: var(--tooltip-bg);
}

.arrow[data-side="inline-start"] {
	inset-inline-end: calc(var(--tooltip-arrow-width) * -1);
	border-inline-end-width: 0;
	border-inline-start-color: var(--tooltip-bg);
}

.arrow[data-side="inline-end"] {
	inset-inline-start: calc(var(--tooltip-arrow-width) * -1);
	border-inline-start-width: 0;
	border-inline-end-color: var(--tooltip-bg);
}
